import { useNavigate } from "react-router-dom";
import { customAuthAxios } from "../../utils/customAuthAxios";
import { switchQrCardImgAppend } from "../../utils/switchQrCardImgAppend";
import { useSuccessToast } from "../toast/useSuccessToast";


export const useEditSoCouponSettingByRestaurant = (settingsId?: string) => {
  const navigate = useNavigate();
  const showToast = useSuccessToast();



  const onSubmit = async (data: any) => {

    try {
      const uploadData = new FormData();

      console.log(data);

      // 通常の値
      uploadData.append("branch_score", data.branch_score);
      uploadData.append("socoupon_in_use", data.socoupon_in_use);
      uploadData.append("remind", data.remind);
      uploadData.append("g_url", data.g_url);
      uploadData.append("default_url", data.default_url);

      // QR画像
      switchQrCardImgAppend(data.qr_card_img, uploadData);


      const res = await customAuthAxios.put(`socoupon/settings/${settingsId}/`, uploadData);


      showToast("編集が完了しました");
      navigate(-1);
    } catch (error: any) {
      console.error("送信エラー:", error);
    }
  };

  return onSubmit;
};